import * as r from "react";
import { n as p, g as G, m as W, u as D, C as k, E as X } from "./CSSMotionList.js";
import { o as M } from "./omit.js";
import "./index.js";
import { K } from "./Keyframes.js";
const O = (e) => {
  const {
    prefixCls: t,
    className: s,
    style: n,
    size: a,
    shape: i
  } = e, c = p({
    [`${t}-lg`]: a === "large",
    [`${t}-sm`]: a === "small"
  }), l = p({
    [`${t}-circle`]: i === "circle",
    [`${t}-square`]: i === "square",
    [`${t}-round`]: i === "round"
  }), o = r.useMemo(() => typeof a == "number" ? {
    width: a,
    height: a,
    lineHeight: `${a}px`
  } : {}, [a]);
  return /* @__PURE__ */ r.createElement("span", {
    className: p(t, c, l, s),
    style: Object.assign(Object.assign({}, o), n)
  });
}, _ = new K("ant-skeleton-loading", {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
}), N = (e) => ({
  height: e,
  lineHeight: D(e)
}), b = (e) => Object.assign({
  width: e
}, N(e)), J = (e) => ({
  background: e.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: _,
  animationDuration: e.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
}), q = (e, t) => Object.assign({
  width: t(e).mul(5).equal(),
  minWidth: t(e).mul(5).equal()
}, N(e)), Q = (e) => {
  const {
    skeletonAvatarCls: t,
    gradientFromColor: s,
    controlHeight: n,
    controlHeightLG: a,
    controlHeightSM: i
  } = e;
  return {
    [t]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: s
    }, b(n)),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    },
    [`${t}${t}-lg`]: Object.assign({}, b(a)),
    [`${t}${t}-sm`]: Object.assign({}, b(i))
  };
}, U = (e) => {
  const {
    controlHeight: t,
    borderRadiusSM: s,
    skeletonInputCls: n,
    controlHeightLG: a,
    controlHeightSM: i,
    gradientFromColor: c,
    calc: l
  } = e;
  return {
    [n]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: c,
      borderRadius: s
    }, q(t, l)),
    [`${n}-lg`]: Object.assign({}, q(a, l)),
    [`${n}-sm`]: Object.assign({}, q(i, l))
  };
}, V = (e) => Object.assign({
  width: e
}, N(e)), Y = (e) => {
  const {
    skeletonImageCls: t,
    imageSizeBase: s,
    gradientFromColor: n,
    borderRadiusSM: a,
    calc: i
  } = e;
  return {
    [t]: Object.assign(Object.assign({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "middle",
      background: n,
      borderRadius: a
    }, V(i(s).mul(2).equal())), {
      [`${t}-path`]: {
        fill: "#bfbfbf"
      },
      [`${t}-svg`]: Object.assign(Object.assign({}, V(s)), {
        maxWidth: i(s).mul(4).equal(),
        maxHeight: i(s).mul(4).equal()
      }),
      [`${t}-svg${t}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    }
  };
}, B = (e, t, s) => {
  const {
    skeletonButtonCls: n
  } = e;
  return {
    [`${s}${n}-circle`]: {
      width: t,
      minWidth: t,
      borderRadius: "50%"
    },
    [`${s}${n}-round`]: {
      borderRadius: t
    }
  };
}, z = (e, t) => Object.assign({
  width: t(e).mul(2).equal(),
  minWidth: t(e).mul(2).equal()
}, N(e)), Z = (e) => {
  const {
    borderRadiusSM: t,
    skeletonButtonCls: s,
    controlHeight: n,
    controlHeightLG: a,
    controlHeightSM: i,
    gradientFromColor: c,
    calc: l
  } = e;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [s]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: c,
      borderRadius: t,
      width: l(n).mul(2).equal(),
      minWidth: l(n).mul(2).equal()
    }, z(n, l))
  }, B(e, n, s)), {
    [`${s}-lg`]: Object.assign({}, z(a, l))
  }), B(e, a, `${s}-lg`)), {
    [`${s}-sm`]: Object.assign({}, z(i, l))
  }), B(e, i, `${s}-sm`));
}, ee = (e) => {
  const {
    componentCls: t,
    skeletonAvatarCls: s,
    skeletonTitleCls: n,
    skeletonParagraphCls: a,
    skeletonButtonCls: i,
    skeletonInputCls: c,
    skeletonImageCls: l,
    controlHeight: o,
    controlHeightLG: m,
    controlHeightSM: d,
    gradientFromColor: g,
    padding: h,
    marginSM: C,
    borderRadius: w,
    titleHeight: E,
    blockRadius: u,
    paragraphLiHeight: y,
    controlHeightXS: P,
    paragraphMarginTop: H
  } = e;
  return {
    [t]: {
      display: "table",
      width: "100%",
      [`${t}-header`]: {
        display: "table-cell",
        paddingInlineEnd: h,
        verticalAlign: "top",
        // Avatar
        [s]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: g
        }, b(o)),
        [`${s}-circle`]: {
          borderRadius: "50%"
        },
        [`${s}-lg`]: Object.assign({}, b(m)),
        [`${s}-sm`]: Object.assign({}, b(d))
      },
      [`${t}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [n]: {
          width: "100%",
          height: E,
          background: g,
          borderRadius: u,
          [`+ ${a}`]: {
            marginBlockStart: d
          }
        },
        // paragraph
        [a]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: y,
            listStyle: "none",
            background: g,
            borderRadius: u,
            "+ li": {
              marginBlockStart: P
            }
          }
        },
        [`${a}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${t}-content`]: {
        [`${n}, ${a} > li`]: {
          borderRadius: w
        }
      }
    },
    [`${t}-with-avatar ${t}-content`]: {
      // Title
      [n]: {
        marginBlockStart: C,
        [`+ ${a}`]: {
          marginBlockStart: H
        }
      }
    },
    // Skeleton element
    [`${t}${t}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, Z(e)), Q(e)), U(e)), Y(e)),
    // Skeleton Block Button, Input
    [`${t}${t}-block`]: {
      width: "100%",
      [i]: {
        width: "100%"
      },
      [c]: {
        width: "100%"
      }
    },
    // With active animation
    [`${t}${t}-active`]: {
      [`
        ${n},
        ${a} > li,
        ${s},
        ${i},
        ${c},
        ${l}
      `]: Object.assign({}, J(e))
    }
  };
}, te = (e) => {
  const {
    colorFillContent: t,
    colorFill: s
  } = e, n = t, a = s;
  return {
    color: n,
    colorGradientEnd: a,
    gradientFromColor: n,
    gradientToColor: a,
    titleHeight: e.controlHeight / 2,
    blockRadius: e.borderRadiusSM,
    paragraphMarginTop: e.marginLG + e.marginXXS,
    paragraphLiHeight: e.controlHeight / 2
  };
}, $ = G("Skeleton", (e) => {
  const {
    componentCls: t,
    calc: s
  } = e, n = W(e, {
    skeletonAvatarCls: `${t}-avatar`,
    skeletonTitleCls: `${t}-title`,
    skeletonParagraphCls: `${t}-paragraph`,
    skeletonButtonCls: `${t}-button`,
    skeletonInputCls: `${t}-input`,
    skeletonImageCls: `${t}-image`,
    imageSizeBase: s(e.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${e.gradientFromColor} 25%, ${e.gradientToColor} 37%, ${e.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return [ee(n)];
}, te, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
}), se = (e) => {
  const {
    prefixCls: t,
    className: s,
    rootClassName: n,
    active: a,
    shape: i = "circle",
    size: c = "default"
  } = e, {
    getPrefixCls: l
  } = r.useContext(k), o = l("skeleton", t), [m, d, g] = $(o), h = M(e, ["prefixCls", "className"]), C = p(o, `${o}-element`, {
    [`${o}-active`]: a
  }, s, n, d, g);
  return m(/* @__PURE__ */ r.createElement("div", {
    className: C
  }, /* @__PURE__ */ r.createElement(O, Object.assign({
    prefixCls: `${o}-avatar`,
    shape: i,
    size: c
  }, h))));
}, ne = (e) => {
  const {
    prefixCls: t,
    className: s,
    rootClassName: n,
    active: a,
    block: i = !1,
    size: c = "default"
  } = e, {
    getPrefixCls: l
  } = r.useContext(k), o = l("skeleton", t), [m, d, g] = $(o), h = M(e, ["prefixCls"]), C = p(o, `${o}-element`, {
    [`${o}-active`]: a,
    [`${o}-block`]: i
  }, s, n, d, g);
  return m(/* @__PURE__ */ r.createElement("div", {
    className: C
  }, /* @__PURE__ */ r.createElement(O, Object.assign({
    prefixCls: `${o}-button`,
    size: c
  }, h))));
}, ae = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", le = (e) => {
  const {
    prefixCls: t,
    className: s,
    rootClassName: n,
    style: a,
    active: i
  } = e, {
    getPrefixCls: c
  } = r.useContext(k), l = c("skeleton", t), [o, m, d] = $(l), g = p(l, `${l}-element`, {
    [`${l}-active`]: i
  }, s, n, m, d);
  return o(/* @__PURE__ */ r.createElement("div", {
    className: g
  }, /* @__PURE__ */ r.createElement("div", {
    className: p(`${l}-image`, s),
    style: a
  }, /* @__PURE__ */ r.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${l}-image-svg`
  }, /* @__PURE__ */ r.createElement("title", null, "Image placeholder"), /* @__PURE__ */ r.createElement("path", {
    d: ae,
    className: `${l}-image-path`
  })))));
}, oe = (e) => {
  const {
    prefixCls: t,
    className: s,
    rootClassName: n,
    active: a,
    block: i,
    size: c = "default"
  } = e, {
    getPrefixCls: l
  } = r.useContext(k), o = l("skeleton", t), [m, d, g] = $(o), h = M(e, ["prefixCls"]), C = p(o, `${o}-element`, {
    [`${o}-active`]: a,
    [`${o}-block`]: i
  }, s, n, d, g);
  return m(/* @__PURE__ */ r.createElement("div", {
    className: C
  }, /* @__PURE__ */ r.createElement(O, Object.assign({
    prefixCls: `${o}-input`,
    size: c
  }, h))));
}, ie = (e) => {
  const {
    prefixCls: t,
    className: s,
    rootClassName: n,
    style: a,
    active: i,
    children: c
  } = e, {
    getPrefixCls: l
  } = r.useContext(k), o = l("skeleton", t), [m, d, g] = $(o), h = p(o, `${o}-element`, {
    [`${o}-active`]: i
  }, d, s, n, g);
  return m(/* @__PURE__ */ r.createElement("div", {
    className: h
  }, /* @__PURE__ */ r.createElement("div", {
    className: p(`${o}-image`, s),
    style: a
  }, c)));
}, re = (e, t) => {
  const {
    width: s,
    rows: n = 2
  } = t;
  if (Array.isArray(s))
    return s[e];
  if (n - 1 === e)
    return s;
}, ce = (e) => {
  const {
    prefixCls: t,
    className: s,
    style: n,
    rows: a = 0
  } = e, i = Array.from({
    length: a
  }).map((c, l) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ r.createElement("li", {
      key: l,
      style: {
        width: re(l, e)
      }
    })
  ));
  return /* @__PURE__ */ r.createElement("ul", {
    className: p(t, s),
    style: n
  }, i);
}, ge = ({
  prefixCls: e,
  className: t,
  width: s,
  style: n
}) => (
  // biome-ignore lint/a11y/useHeadingContent: HOC here
  /* @__PURE__ */ r.createElement("h3", {
    className: p(e, t),
    style: Object.assign({
      width: s
    }, n)
  })
);
function R(e) {
  return e && typeof e == "object" ? e : {};
}
function me(e, t) {
  return e && !t ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function de(e, t) {
  return !e && t ? {
    width: "38%"
  } : e && t ? {
    width: "50%"
  } : {};
}
function ue(e, t) {
  const s = {};
  return (!e || !t) && (s.width = "61%"), !e && t ? s.rows = 3 : s.rows = 2, s;
}
const f = (e) => {
  const {
    prefixCls: t,
    loading: s,
    className: n,
    rootClassName: a,
    style: i,
    children: c,
    avatar: l = !1,
    title: o = !0,
    paragraph: m = !0,
    active: d,
    round: g
  } = e, {
    getPrefixCls: h,
    direction: C,
    className: w,
    style: E
  } = X("skeleton"), u = h("skeleton", t), [y, P, H] = $(u);
  if (s || !("loading" in e)) {
    const S = !!l, v = !!o, j = !!m;
    let A;
    if (S) {
      const x = Object.assign(Object.assign({
        prefixCls: `${u}-avatar`
      }, me(v, j)), R(l));
      A = /* @__PURE__ */ r.createElement("div", {
        className: `${u}-header`
      }, /* @__PURE__ */ r.createElement(O, Object.assign({}, x)));
    }
    let L;
    if (v || j) {
      let x;
      if (v) {
        const I = Object.assign(Object.assign({
          prefixCls: `${u}-title`
        }, de(S, j)), R(o));
        x = /* @__PURE__ */ r.createElement(ge, Object.assign({}, I));
      }
      let T;
      if (j) {
        const I = Object.assign(Object.assign({
          prefixCls: `${u}-paragraph`
        }, ue(S, v)), R(m));
        T = /* @__PURE__ */ r.createElement(ce, Object.assign({}, I));
      }
      L = /* @__PURE__ */ r.createElement("div", {
        className: `${u}-content`
      }, x, T);
    }
    const F = p(u, {
      [`${u}-with-avatar`]: S,
      [`${u}-active`]: d,
      [`${u}-rtl`]: C === "rtl",
      [`${u}-round`]: g
    }, w, n, a, P, H);
    return y(/* @__PURE__ */ r.createElement("div", {
      className: F,
      style: Object.assign(Object.assign({}, E), i)
    }, A, L));
  }
  return c ?? null;
};
f.Button = ne;
f.Avatar = se;
f.Input = oe;
f.Image = le;
f.Node = ie;
process.env.NODE_ENV !== "production" && (f.displayName = "Skeleton");
export {
  f as S
};
